import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

/** Propuestas de examen: profesor propone alumno, admin acepta/rechaza. */
@Injectable({ providedIn: 'root' })
export class ExamProposalService {
  private base = `${environment.API_URL}/exam-proposals`;

  constructor(private http: HttpClient) {}

  list(proofId: number): Observable<any> {
    return this.http.get<any>(`${this.base}`, { params: { proof_id: proofId } as any });
  }

  create(payload: { proof_id: number; user_id: number; license_id: number; note?: string }): Observable<any> {
    return this.http.post<any>(`${this.base}`, payload);
  }

  accept(id: number, body: any = {}): Observable<any> {
    return this.http.post<any>(`${this.base}/${id}/accept`, body);
  }

  reject(id: number): Observable<any> {
    return this.http.post<any>(`${this.base}/${id}/reject`, {});
  }

  remove(id: number): Observable<any> {
    return this.http.delete<any>(`${this.base}/${id}`);
  }
}
